import {
  EuiButtonIcon,
  EuiHealth,
  EuiLink,
  euiPaletteColorBlindBehindText,
} from "@elastic/eui";
import {
  ActionIcon,
  Anchor,
  Button,
  Divider,
  Flex,
  Grid,
  Group,
  Input,
  Rating,
  Select,
  Title,
  Tooltip,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import { IconPackage, IconSearch, IconStatusChange } from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { styleTableMantine } from "../../../_base/_const/_constVar";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import Repository from "../../../_base/helper/HttpHelper";
import { modifyDisableUserReview } from "../../../api/apiUserReview";
import AppAction from "../../../common/AppAction";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";
import { API_ROUTE } from "../../../const/apiRoute";
import { MessageResponse } from "../../../model/MessageResponse";
import { TblUserReview } from "../../../model/TblUserReview";
import ModalUpdateExcelProduct from "../../ProductManager/ProductList/ModalUpdate/ModalUpdateExcelProduct";
import DeleteView from "./DeleteView";
import EditView from "./EditView";

const UserReviewList = () => {
  // const columns: Array<EuiBasicTableColumn<any>> = [
  //   {
  //     field: "id",
  //     name: "ID",
  //     sortable: true,
  //     truncateText: true,
  //     width: "3%",
  //   },
  //   {
  //     field: "",
  //     name: "Thông tin khách hàng",
  //     sortable: true,
  //     truncateText: true,
  //     render: (online: TblUserReview) => (
  //       <Box>
  //         <Text lineClamp={2}>
  //           <EuiLink
  //             style={{ fontSize: 16, fontWeight: 700 }}
  //             target="_blank"
  //             onClick={(e: any) => {
  //               handleEditData(online);
  //             }}
  //           >
  //             {online.userName}
  //           </EuiLink>
  //         </Text>

  //         <Text>{online.userEmail}</Text>
  //         <Text>{online.creationDate}</Text>
  //       </Box>
  //     ),
  //   },

  //   {
  //     field: "",
  //     name: "Nội dung",
  //     sortable: true,
  //     truncateText: true,
  //     width: "70%",
  //     render: (online: TblUserReview) => (
  //       <Box>
  //         <div className={styles.ctitle}>
  //           <span>{online.itemTitle}</span>
  //           <Rating defaultValue={online?.rate || 0} fractions={2} readOnly />
  //         </div>
  //         {selectedEdit === online ? (
  //           <form onSubmit={form.onSubmit(() => handleUpdateReview())}>
  //             <TextInput
  //               label="Tiêu đề"
  //               key={form.key("title")}
  //               {...form.getInputProps("title")}
  //             />
  //             <Textarea
  //               mt={"sm"}
  //               label="Nội dung"
  //               key={form.key("content")}
  //               {...form.getInputProps("content")}
  //             />
  //             <Flex mt={"md"} gap={"sm"} mb={"sm"}>
  //               <Button type="submit">Cập nhật</Button>
  //               <Button variant="default" onClick={() => setSelectedEdit(null)}>
  //                 Huỷ
  //               </Button>
  //             </Flex>
  //           </form>
  //         ) : (
  //           <div className={styles.content}>{online.content}</div>
  //         )}
  //       </Box>
  //     ),
  //   },
  //   {
  //     field: "approved",
  //     name: "Trạng thái",
  //     sortable: true,
  //     truncateText: true,
  //     width: "8%",
  //     render: (approved: number, online: TblUserReview) => (
  //       <EuiLink
  //         // style={{ fontSize: 16, fontWeight: 700 }}
  //         target="_blank"
  //         onClick={(e: any) => {
  //           handleEditDisable(online.id);
  //         }}
  //       >
  //         <EuiHealth color={approved == 1 ? "green" : "danger"}>
  //           {approved == 1 ? "Đã duyệt" : "Chưa duyệt"}
  //         </EuiHealth>
  //       </EuiLink>
  //     ),
  //   },
  //   {
  //     name: "Actions",
  //     width: "5%",
  //     render: (online: any) => {
  //       return (
  //         <>
  //           <EuiFlexGroup
  //             responsive={true}
  //             wrap={false}
  //             gutterSize="s"
  //             alignItems="center"
  //           >
  //             <EuiFlexItem grow={false}>
  //               <EuiButtonIcon
  //                 iconType="documentEdit"
  //                 aria-label="Dashboard"
  //                 color="success"
  //                 onClick={(e: any) => {
  //                   if (isNullOrUndefined(online))
  //                     NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
  //                   else {
  //                     editItem(online);
  //                   }
  //                 }}
  //               />
  //             </EuiFlexItem>
  //             <EuiFlexItem grow={false}>
  //               <EuiButtonIcon
  //                 iconType="trash"
  //                 color="danger"
  //                 onClick={(e: any) => {
  //                   if (isNullOrUndefined(online))
  //                     NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
  //                   else {
  //                     deleteItem([online.id]);
  //                   }
  //                 }}
  //               />
  //             </EuiFlexItem>
  //           </EuiFlexGroup>
  //         </>
  //       );
  //     },
  //   },
  // ];
  // const Content = () => {
  //   modals.openConfirmModal({
  //     title: (
  //       <>
  //         <Title order={5}>Xóa đánh giá</Title>
  //       </>
  //     ),
  //     children: 123,
  //     confirmProps: { display: "none" },
  //     cancelProps: { display: "none" },
  //   });
  // };

  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [datas, setDatas] = useState<TblUserReview[]>([]);
  const [total, setTotal] = useState(0);
  const [height, setHeight] = useState(0);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [isLoading, setIsLoading] = useState(false);
  const [selectIds, setSelectIds] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  type SearchCriteria = {
    keySearch?: string;
    ItemSearch?: string;
    Active?: number;
    Approved?: string;
    Rate?: number;
  };

  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [ratingValue, setRatingValue] = useState<number>(
    _searchJson && checkedPinSearch ? _searchJson?.Rate : 0
  );

  const form = useForm<SearchCriteria>({
    mode: "uncontrolled",
    initialValues: {
      keySearch: _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
      ItemSearch:
        _searchJson && checkedPinSearch ? _searchJson?.ItemSearch : "",
      Approved: _searchJson && checkedPinSearch ? _searchJson?.Approved : "",
      Rate: _searchJson && checkedPinSearch ? _searchJson?.Rate : 0,
    },
  });

  // const handleEditData = async (data: TblUserReview) => {
  //   if (data) {
  //     editItem(data);
  //   } else {
  //     NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
  //   }
  // };
  const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;
  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "id",
        header: "ID",
        size: 50,
      },
      {
        accessorKey: "userName",
        header: "Khách hàng",
      },
      {
        accessorKey: "userEmail",
        header: "Email khách hàng",
      },
      {
        accessorKey: "creationDate",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "itemName",
        header: "Tên sản phẩm",
        Cell: ({ cell, row }) => (
          <Anchor
            style={{
              whiteSpace: "normal",
              wordWrap: "break-word",
              wordBreak: "break-word",
              lineHeight: "1.4",
              maxWidth: "280px", // Giới hạn chiều rộng để text xuống dòng
              padding: "4px 0",
            }}
            target="_blank"
            href={`${hacomUrl}/${row.original.itemUrl}`}
            underline="always"
            onClick={(e) => e.stopPropagation()}
          >
            {cell.getValue<string>()}
          </Anchor>
        ),
        size: 300,
      },
      {
        accessorKey: "rate",
        header: "Đánh giá",
        Cell: ({ row }) => {
          const online = row.original;
          return (
            <Rating defaultValue={online?.rate || 0} fractions={2} readOnly />
          );
        },
      },
      {
        accessorKey: "content",
        header: "Nội dung",
        size: 300,
        Cell: ({ renderedCellValue }) => (
          <div
            style={{
              whiteSpace: "normal",
              wordWrap: "break-word",
              wordBreak: "break-word",
              lineHeight: "1.4",
              maxWidth: "280px", // Giới hạn chiều rộng để text xuống dòng
              padding: "4px 0",
            }}
          >
            {renderedCellValue}
          </div>
        ),
      },
      {
        id: "approved",
        header: "Trạng thái",
        Cell: ({ row }) => {
          const online = row.original;
          return (
            <EuiLink
              target="_blank"
              onClick={() => handleEditDisable(online.id)}
            >
              <EuiHealth color={online.approved === 1 ? "green" : "danger"}>
                {online.approved === 1 ? "Đã duyệt" : "Chưa duyệt"}
              </EuiHealth>
            </EuiLink>
          );
        },
        size: 120,
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        Cell: ({ row }) => {
          const online = row.original;
          return (
            <Group justify="center" gap="xs">
              <Tooltip label="Chỉnh sửa">
                <ActionIcon
                  variant="subtle"
                  aria-label="Edit"
                  onClick={() => {
                    if (!online) {
                      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
                    } else {
                      editItem(online);
                    }
                  }}
                >
                  <EuiButtonIcon iconType="documentEdit" color="success" />
                </ActionIcon>
              </Tooltip>

              <Tooltip label="Xoá">
                <ActionIcon
                  variant="subtle"
                  aria-label="Delete"
                  onClick={() => {
                    if (!online) {
                      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
                    } else {
                      deleteItem([online.id]);
                    }
                  }}
                >
                  <EuiButtonIcon iconType="trash" color="danger" />
                </ActionIcon>
              </Tooltip>
            </Group>
          );
        },
        size: 100,
        enableSorting: false,
        enableColumnActions: false,
      },
    ],
    [datas, deleteViewStatus]
  );
  const handleEditDisable = async (id: number) => {
    await modifyDisableUserReview(id);
    fetchDataUserReview();
  };

  // const handleUpdateReview = async () => {
  //   const dataModify = {
  //     ...selectedEdit,
  //     //       title: selectedEditTitle,
  //     // content: selectedEditContent,
  //     // title: form.getValues().title,
  //     // content: form.getValues().content,
  //   };
  //   await modifyUserReview(dataModify);
  //   fetchDataUserReview();
  // };

  // const onTableChange = async ({
  //   page: { index, size },
  // }: CriteriaWithPagination<any>) => {
  //   setPagination({
  //     ...pagination,
  //     pageIndex: index,
  //     pageSize: size,
  //     totalItemCount: 1000,
  //   });
  // };

  // const onChangeApproved = (value: any) => {
  //   setSelectedApproved(value);
  // };

  // const onChangeRating = (value: any) => {
  //   setSelectedRating(value);
  // };

  // const handleChangeID = (selectedValue: any) => {
  //   setInputID(selectedValue.target.value);
  // };

  // const onChange = (selectedOptions: any) => {
  //   setSelected(selectedOptions);
  //   if (!isNullOrUndefinedArry(selectedOptions)) {
  //     const value = selectedOptions[0].value;
  //     if (!isNullOrUndefined(value))
  //       setParamSearch({ ...paramSearch, inActive: value });
  //   } else setParamSearch({ ...paramSearch, inActive: undefined });
  // };

  // const onChangeText = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const key = event?.target?.value;
  //   if (!isNullOrUndefined(key))
  //     setParamSearch({ ...paramSearch, keyWord: key });
  // };

  // const onSelectionChange = (selectedItems: any[]) => {
  //   setSelectedItems(selectedItems);
  // };
  // const selection: EuiTableSelectionType<any> = {
  //   selectable: (user: any) => true,
  //   selectableMessage: (selectable: boolean) =>
  //     !selectable ? "User is currently offline" : "",
  //   onSelectionChange,
  // };

  // const openModalEdit = (data: TblUserReview) => {
  //   if (selectIds && (selectIds.length < 1 || selectIds.length > 1))
  //     NotificationExtension.Warn(
  //       "Xin vui lòng chọn 1 danh mục bài viết để chỉnh sửa !"
  //     );
  //   else {
  //     editItem(data);
  //   }
  // };

  const openModalDelete = () => {
    if (selectIds && selectIds.length < 1)
      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
    else {
      const ids = selectIds.map((id) => Number(id));
      // console.log("object", ids);
      deleteItem(ids);
    }
  };

  function deleteItem(idItem: number[]) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xóa đánh giá</Title>
        </>
      ),
      children: <DeleteView onClose={setDeleteViewStatus} idItem={idItem} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function editItem(data: TblUserReview) {
    // setSelectedEdit(data);
    // // setSelectedEditTitle(data?.title || undefined);
    // // setSelectedEditContent(data?.content || undefined);

    // form.setFieldValue("title", data?.title || "");
    // form.setFieldValue("content", data?.content || "");
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Cập nhật đánh giá</Title>
        </>
      ),
      children: <EditView data={data} onClose={fetchDataUserReview} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });
  }

  // const elementSearch = [
  //   <Menu.Item closeMenuOnClick={false}>
  //     <EuiFormRow label="Trạng thái">
  //       <Select
  //         placeholder={"Chọn trạng thái"}
  //         searchable
  //         defaultValue={selectedApproved}
  //         nothingFoundMessage="Không có dữ liệu"
  //         data={optionApproved}
  //         onChange={onChangeApproved}
  //         clearable
  //       />
  //     </EuiFormRow>
  //   </Menu.Item>,
  //   <Menu.Item closeMenuOnClick={false}>
  //     <EuiFormRow label="Đánh giá">
  //       <Select
  //         placeholder={"Chọn số sao"}
  //         searchable
  //         defaultValue={selectedRating}
  //         nothingFoundMessage="Không có dữ liệu"
  //         data={optionRating}
  //         onChange={onChangeRating}
  //         clearable
  //       />
  //     </EuiFormRow>
  //   </Menu.Item>,
  //   <Menu.Item closeMenuOnClick={false}>
  //     <EuiFormRow label="ID sản phẩm">
  //       <Input
  //         placeholder={"Nhập ID sản phẩm"}
  //         value={inputID}
  //         onChange={handleChangeID}
  //         rightSectionPointerEvents="all"
  //         rightSection={
  //           <CloseButton
  //             onClick={() => setInputID("")}
  //             style={{ display: inputID ? undefined : "none" }}
  //           />
  //         }
  //       />
  //     </EuiFormRow>
  //   </Menu.Item>,
  // ];

  const fetchDataUserReview = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
    const search = form.getValues();
    try {
      let urlSearch = `${API_ROUTE.GET_LIST_USER_REVIEW}?Skip=${
        pagination?.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;
      // if (!isNullOrEmpty(keyWord))
      //   urlSearch = urlSearch + `&KeySearch=` + keyWord;
      // if (!isNullOrUndefined(inActive))
      //   urlSearch = urlSearch + `&Active=` + inActive;
      // if (!isNullOrUndefined(selectedApproved) && selectedApproved !== "")
      //   urlSearch = urlSearch + `&Approved=` + selectedApproved;
      // if (!isNullOrUndefined(selectedRating) && selectedRating !== "")
      //   urlSearch = urlSearch + `&Rate=` + selectedRating;
      // if (!isNullOrUndefined(inputID) && inputID !== "") {
      //   urlSearch = urlSearch + `&ItemId=${inputID}`;
      // }
      if (search.keySearch) {
        urlSearch += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
      }
      if (search.Approved) {
        urlSearch += `&Approved=${search.Approved.trim().toLowerCase()}`;
      }
      if (search.Rate) {
        urlSearch += `&Rate=${search.Rate}`;
      }
      if (search.ItemSearch) {
        urlSearch += `&ItemSearch=${search.ItemSearch.trim().toLowerCase()}`;
      }
      let callapi = await repository.get<MessageResponse<any>>(urlSearch);
      if (callapi && callapi.success) {
        setDatas(callapi?.data ?? []);
        setRowCount(callapi?.totalCount ?? 0);
        setTotal(callapi?.totalCount ?? 0);
        setSelectIds([]);
        table.resetRowSelection();
      } else {
        setDatas([]);
        setRowCount(0);
        setIsLoading(false);
      }
      return callapi?.data;
    } catch (error: any) {
      setDatas([]);
      setIsError(true);
      return null;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...form.getValues(),
          pageSize: pagination.pageSize,
          pageIndex: pagination.pageIndex,
        })
      );
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchDataUserReview();
    };
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize, deleteViewStatus]);

  const table = useMantineReactTable({
    columns,
    data: datas,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    enableTopToolbar: false,
    enablePagination: true,
    localization: _localization,
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    enableRowSelection: true,
    enableStickyFooter: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "userName"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    getRowId: (row) => row.id,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    // mantineTableBodyRowProps: ({ row }) => ({
    //   onClick: row.getToggleSelectedHandler(),
    //   sx: { cursor: "pointer" },
    // }),
  });
  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (250 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  // useEffect(() => {
  //   if (_searchJson) {
  //     setPagination({
  //       pageIndex: _searchJson.pageIndex,
  //       pageSize: _searchJson.pageSize,
  //     });
  //   }
  // }, []);

  // hàm mở modal để cập nhật file excel
  const openModalupdateExel = () => {
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Tạo review sản phẩm bằng Excel</Title>
          </div>
        </>
      ),
      children: <ModalUpdateExcelProduct location={location} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  return (
    <>
      <Flex
        gap="md"
        justify={"space-between"}
        align="center"
        direction="row"
        wrap="wrap"
        w={"100%"}
      >
        <BreadCrumb></BreadCrumb>
        <AppAction
          // openModal={openModal}
          // openModalDelete={openModalDelete}
          // openModalEdit={openModalEdit}
          // isUpdateSearchItem={true}
          openModalupdateExel={openModalupdateExel}
          // exportExcel={exportExcel}
        ></AppAction>
      </Flex>
      <Divider my="sm" />
      {/* 
      
      <Divider my="sm" />
      <AppSearch
        loading={loading}
        onChange={onChange}
        onChangeText={onChangeText}
        onSearch={() => fetchDataUserReview()}
        elementSearch={elementSearch}
      /> */}
      {/* <EuiSpacer size="l" /> */}
      {/* <EuiBasicTable
        tableCaption="Demo of EuiDataGrid with selection"
        items={datas ? datas : []}
        itemId="id"
        error={error}
        loading={loading}
        noItemsMessage={"Không có dữ liệu"}
        selection={selection}
        columns={columns}
        pagination={pagination}
        isSelectable={true}
        hasActions={true}
        responsive={true}
        onChange={onTableChange}
        compressed={true}
      /> */}
      <Grid justify="space-between" align="center" mb={10}>
        <Grid.Col span="auto">
          <Group gap="sm">
            <Input
              placeholder="Nhập tìm kiếm"
              key={form.key("keySearch")}
              type="text"
              leftSection={<IconSearch size={20} color="#15aabf" />}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchDataUserReview();
                }
              }}
              {...form.getInputProps("keySearch")}
              w={200}
            />
            <Input
              placeholder="Nhập tên sản phẩm/SKU"
              key={form.key("ItemSearch")}
              type="text"
              leftSection={<IconPackage size={20} color="#15aabf" />}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchDataUserReview();
                }
              }}
              {...form.getInputProps("ItemSearch")}
              w={200}
            />
            <Select
              placeholder="Trạng thái"
              searchable
              w={200}
              leftSection={<IconStatusChange size={20} color="#15aabf" />}
              data={[
                {
                  value: "0",
                  label: "Chưa duyệt",
                },
                {
                  value: "1",
                  label: "Đã duyệt",
                },
              ]}
              {...form.getInputProps("Approved")}
              clearable
            />

            <Flex align="center" w={120}>
              <Rating
                value={ratingValue}
                onChange={(value) => {
                  if (value === ratingValue) {
                    setRatingValue(0);
                    form.setFieldValue("Rate", 0);
                  } else {
                    setRatingValue(value);
                    form.setFieldValue("Rate", value);
                  }
                }}
              />
              {ratingValue > 0 && (
                <ActionIcon
                  onClick={() => {
                    setRatingValue(0);
                    form.setFieldValue("Rate", 0);
                  }}
                  size="md"
                  ml={5}
                  variant="light"
                  color="red"
                  radius="xl"
                >
                  X
                </ActionIcon>
              )}
            </Flex>
            <Button
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchDataUserReview();
              }}
            >
              Tìm kiếm
            </Button>
          </Group>
        </Grid.Col>

        <Grid.Col span="content">
          <Group justify="flex-end">
            <AppAction
              openModalDelete={openModalDelete}
              // openModalEdit={openModalEdit}
            />
          </Group>
        </Grid.Col>
      </Grid>
      <MantineReactTable table={table} />
    </>
  );
};

export default UserReviewList;
